import Vue from "vue";
import { MutationTree } from "vuex";
import { IReceptionState } from "./state";
import {
    IReceptionDay,
    ReceptionType,
    IReception,
    IOtherAppointment,
    IReceptionNotification,
    NotificationType,
    ISlot,
} from "@/models";
import {
    ADD_RECEPTION_DAYS,
    ADD_NOTIFICATIONS,
    ADD_NOTIFICATION,
    ADD_RECEPTION,
    MANAGE_NOTIFICATION,
    EDIT_RECEPTION,
    ADD_OTHER,
    ADD_VALIDATION_PICTURE,
    REMOVE_VALIDATION_PICTURE,
    SET_SELECTED_NOTIFICATION,
    SET_SELECTED_RECEPTION,
    CLEAN_RECEPTION,
    EDIT_SELECTED_RECEPTION,
    DELETE_RECEPTION,
    SET_RECEPTION_START_SLOT,
    SET_RECEPTION_END_SLOT,
} from "./mutations-types";

export const mutations: MutationTree<IReceptionState> = {
    [ADD_RECEPTION_DAYS](state, payload: IReceptionDay): void {
        state.receptionDay = payload;
    },

    [ADD_NOTIFICATIONS](state, payload: IReceptionNotification[]): void {
        state.notifications = state.notifications.concat(payload);
    },

    [ADD_NOTIFICATION](state, payload: IReceptionNotification): void {
        state.notifications.push(payload);
    },

    [ADD_RECEPTION](state, payload: IReception): void {
        if (payload.type === ReceptionType.DryMaterials) {
            state.receptionDay.dryMaterials.push({ slotId: payload.slotId, reception: payload });
        } else {
            state.receptionDay.glasswares.push({ slotId: payload.slotId, reception: payload });
        }
    },

    [MANAGE_NOTIFICATION](state, notification: IReceptionNotification): void {
        let indexToRemove;
        if (notification.type === NotificationType.AskAppointment) {
            indexToRemove = state.notifications.findIndex(n => n.askAppointment !== null && n.askAppointment.askAppointmentId === notification.askAppointment.askAppointmentId);
        } else {
            indexToRemove = state.notifications.findIndex(n => n.reception !== null && n.reception.receptionId === notification.reception.receptionId);
        }

        if (indexToRemove !== -1) {
            state.notifications.splice(indexToRemove, 1);
        } else {
            state.notifications.unshift(notification);
        }
    },

    [EDIT_RECEPTION](state, reception: IReception): void {
        if (reception.type === ReceptionType.DryMaterials) {
            if (new Date(state.receptionDay.day).getDate() === new Date(reception.expectedArrival).getDate()) {
                const index = state.receptionDay.dryMaterials.findIndex(x => x.reception.receptionId === reception.receptionId);

                Vue.set(state.receptionDay.dryMaterials, index, { slotId: reception.slotId, reception });
            }
            else {
                const index = state.receptionDay.dryMaterials.findIndex(x => x.reception.receptionId === reception.receptionId);
                state.receptionDay.dryMaterials.splice(index, 1);
            }
        }
        else {
            if (new Date(state.receptionDay.day).getDate() === new Date(reception.expectedArrival).getDate()) {
                const index = state.receptionDay.glasswares.findIndex(x => x.reception.receptionId === reception.receptionId);

                Vue.set(state.receptionDay.glasswares, index, { slotId: reception.slotId, reception });
            }
            else {
                const index = state.receptionDay.glasswares.findIndex(x => x.reception.receptionId === reception.receptionId);
                state.receptionDay.glasswares.splice(index, 1);
            }
        }

        if (state.selectedReception !== null && reception.receptionId === state.selectedReception.receptionId) {
            state.selectedReception = reception;
        }
    },

    [ADD_OTHER](state, otherAppointment: IOtherAppointment): void {
        state.receptionDay.otherAppointments.find(x => x.slotId === otherAppointment.slotId).otherAppointment = otherAppointment;
    },

    [ADD_VALIDATION_PICTURE](state, picture: any): void {
        state.validationPictures.unshift(picture);
    },

    [REMOVE_VALIDATION_PICTURE](state, index: number): void {
        state.validationPictures.splice(index, 1);
    },

    [SET_SELECTED_NOTIFICATION](state, notification: IReceptionNotification) {
        state.selectedNotification = notification;
    },

    [SET_SELECTED_RECEPTION](state, reception: IReception) {
        state.selectedReception = reception;
    },

    [CLEAN_RECEPTION](state) {
        state.validationPictures = [];
        state.selectedReception = null;
    },

    [EDIT_SELECTED_RECEPTION](state, reception: IReception) {
        state.selectedReception = reception;
    },

    [DELETE_RECEPTION](state, data: any) {
        if (data.type === ReceptionType.DryMaterials) {
            const index = state.receptionDay.dryMaterials.findIndex(x => x.slotId === data.slotId);
            state.receptionDay.dryMaterials.splice(index, 1);
        }
        else {
            const index = state.receptionDay.glasswares.findIndex(x => x.slotId === data.slotId);
            state.receptionDay.glasswares.splice(index, 1);
        }

        const indexToRemove = state.notifications.findIndex(n => n.reception !== null && n.reception.receptionId === data.receptionId);

        if (indexToRemove > -1) {
            state.notifications.splice(indexToRemove, 1);
        }
    },

    [SET_RECEPTION_START_SLOT](state, slot: ISlot) {
        state.receptionStartSlot = slot;
    },

    [SET_RECEPTION_END_SLOT](state, slot: ISlot) {
        state.receptionEndSlot = slot;
    },
};
